import { h } from 'preact';
import Store from 'store/store';
import 'store/bolt/tiledItems';
import { debounce, joinClasses, sortObjectByOrder } from 'utils/utils';
import { getSizeOverride, onMarkdownClick } from 'utils/bolt/index';

import HTML from 'components/core/html/html';
import Section from 'components/bolt/section/section';
import Tile from 'components/bolt/tiledItems/tile/tile';

import s from 'components/bolt/tiledItems/tiledItems.sss';

export default class TiledItems extends Section {
	constructor(props) {
		super(props);

		this.state = {
			tilesArray: []
		};

		this.$tileRefs = {};
		this.onResize = debounce(this.onResize.bind(this));
	}

	componentDidMount() {
		super.componentDidMount();

		window.addEventListener('resize', this.onResize);
		this.getTilesArray();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
		Store.emit('ADD_TILED_ITEMS_FOOTER_SHADOW', false);
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.id !== prevProps.id) {
			this.getTilesArray();
		}
		if (prevState.tilesArray !== this.state.tilesArray) {
			this.getShortestTile();
		}
	}

	onClick(e) {
		onMarkdownClick(e);
	}

	onResize() {
		this.getShortestTile();
	}

	getShortestTile() {
		const height = Object.values(this.$tileRefs).filter(e => e).map(e => e.getNaturalContentHeight()).sort((a, b) => a - b)[0];
		this.setState({ shortestTile: Math.max(height, 450) });
	}

	getTilesArray() {
		let tilesArray = this.splitTiles(this.props.data?.tiles);
		if (!tilesArray.length) return;

		this.setState({ tilesArray });

		if (!this.props.isSection) {
			// Is there a better way to handle this? (without breaking existing sites)
			const isDesktopSize = this.props.client?.deviceSize === 'desktop' || this.props.client?.deviceSize === 'largeDesktop';
			const needsFooterShadow = isDesktopSize ? tilesArray.length % 2 === 0 : tilesArray[tilesArray.length - 1]?.tilesData?.length % 2 === 0;
			Store.emit('ADD_TILED_ITEMS_FOOTER_SHADOW', needsFooterShadow);
		}
	}

	splitTiles(tiles) {
		tiles = sortObjectByOrder(tiles);
		if (tiles.length !== 1) return tiles;

		const orientation = tiles[0].orientation;
		const allTiles = sortObjectByOrder(tiles[0].tilesData);

		// NOTE: we should probably not group things here (see note in renderTiles)
		const batchSize = 2;
		const output = [];
		for (let i = 0; i < allTiles.length; i += batchSize) {
			output.push({ tilesData: allTiles.slice(i, i + batchSize), orientation });
		}
		return output;
	}

	renderTiles() {
		const isDesktopSize = this.props.client?.deviceSize === 'desktop' || this.props.client?.deviceSize === 'largeDesktop';
		const { tilesArray, shortestTile } = this.state;

		const appData = this.props.appData;
		// We should have a way to disable the automatic height
		let fixedHeight = getSizeOverride(appData?.pages?.[this.props.id]?.data?.customTileSize);
		const height = fixedHeight || (shortestTile != undefined ? `${shortestTile}px` : '');

		// TODO: why is the JS responsible for splitting into rows rather than using CSS grid/flex and making things adapt to the available space?
		const rows = isDesktopSize
			? tilesArray
			: tilesArray.flatMap(row => {
				// Check if tilesData is an array, otherwise convert it
				let tilesData = Array.isArray(row.tilesData) ? row.tilesData : Object.values(row.tilesData);

				if (!Array.isArray(tilesData)) {
					console.error('Invalid row.tilesData:', tilesData);
					return [];
				}

				return tilesData.map(tile => ({ ...row, tilesData: [tile] }));
			});


		return rows.map((items, index) => {
			const { tilesData, orientation } = items;
			const isPortrait = orientation === 'portrait';
			if (!tilesData) return;
			const rowData = sortObjectByOrder(tilesData).map((tile, i) => {
				return	(
					<Tile
						ref={e => this.$tileRefs[`tile${i}-${index}`] = e}
						data={tile}
						isPortrait={isPortrait}
						isEvenRow={index % 2 === 0}
						height={height}
					/>
				);
			});

			return (
				<div class={s.row}>
					<div class={joinClasses(s.tiles, isPortrait && s.portraitTiles)}>
						{rowData}
					</div>
				</div>
			);
		}).filter(item => item);
	}

	renderTitle() {
		const content = this.props.data?.title;
		return <HTML class={joinClasses(s.pageTitle, 'xlargeB')} content={content} markdown inline onClickCapture={this.onClick} key="title" />;
	}

	renderSubtitle() {
		const content = this.props.data?.description;
		if (!content) return;
		return <HTML tag="h2" class={s.pageSubtitle} content={content} markdown inline key="subtitle" />;
	}

	render(props, state) {
		return (
			<div class={joinClasses(s.wrapper, props.isSection && s.section)} data-section={props.id}>
				{this.renderBgContent()}
				{this.renderTitle()}
				{this.renderSubtitle()}
				<div class={s.tileWrapper} key="tiles">
					{this.renderTiles()}
				</div>
			</div>
		);
	}
}
